import type { ProjectJob } from '../api/types';

/** URLهای ارسال‌شده در یک job (از meta یا نتایج). */
export function urlsFromProjectJob(job: ProjectJob): string[] {
  const metaUrls = job.meta?.urls;
  if (Array.isArray(metaUrls)) {
    const fromMeta = metaUrls.filter(
      (item): item is string =>
        typeof item === 'string' && item.trim().length > 0,
    );
    if (fromMeta.length > 0) return [...new Set(fromMeta)];
  }
  const fromResults = (job.results ?? []).map((row) => row.url).filter(Boolean);
  return [...new Set(fromResults)];
}
